import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridModule } from 'src/layout/grid/grid.module';
import { UspBulkElementComponent } from './usp-bulk.component';



@NgModule({
    declarations: [UspBulkElementComponent],
    imports: [
        CommonModule,
        GridModule,
    ],
    exports: [UspBulkElementComponent]
})
export class UspBulkModule {
    static components = { 'uspBulkElement': UspBulkElementComponent };
}
